import { render, staticRenderFns } from "./BaseInputFileGroup.vue?vue&type=template&id=0d16c6eb&scoped=true&"
import script from "./BaseInputFileGroup.vue?vue&type=script&lang=js&"
export * from "./BaseInputFileGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseInputFileGroup.vue?vue&type=style&index=0&id=0d16c6eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d16c6eb",
  null
  
)

export default component.exports